/**
 * Проверяем является ли текущий пользователь владельцем сообщения
 */
export function isMessageOwner(session_id: string): boolean {
  const params = APP.retChannel?.socket?.params() || {};

  return params.session_id === session_id;
}
